/**
 * PrivacyENPrivacyPageView
 *
 * Page component for PrivacyENPrivacyPageView
 * Path: /privacy
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { PrivacyENPrivacyPageView as __PrivacyENPrivacyPageView } from '@/components/traits/PrivacyENPrivacyPageView';
import { PrivacyENPrivacyAnalyticsView as __PrivacyENPrivacyAnalyticsView } from '@/components/traits/PrivacyENPrivacyAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface PrivacyENPrivacyPageViewProps {
  // Add any page-level props here
}

export function PrivacyENPrivacyPageView(_props: PrivacyENPrivacyPageViewProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-almadar-privacy:meta.title"],"description":["i18n/t","std-almadar-privacy:meta.description"],"access":"public","indexing":"index","origin":"https://almadar.io","siteName":"Almadar","alternates":[{"locale":"en","path":"/privacy"},{"locale":"ar","path":"/ar/privacy"},{"locale":"sl","path":"/sl/privacy"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__PrivacyENPrivacyPageView config={{ initPayload: __navState }} />
          <__PrivacyENPrivacyAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default PrivacyENPrivacyPageView;
